export default __webpack_public_path__ + "static/26834-0e39f887df7159a88b0226f771ed2489.jpg";